import { authActions } from ".";
import {
  loginService,
  profileService,
  logoutService,
} from "./authServices";
import { notification } from "antd";
import { setUserSession } from "../../components/utils/common";

export const loginAction = (data) => {
  return async (dispatch) => {
    try {
      dispatch(authActions.setIsFetching(true));
      const res = await loginService(data);
      if (res?.status === "1") {
        dispatch(authActions.setIsLoggingIn(true));
        dispatch(authActions.setIsFetching(false));
        return { type: true, token: res?.data?.token };
      } else {
        dispatch(authActions.login({ error: res.data, isAuth: false }));
        dispatch(authActions.login({ error: null }));
        dispatch(authActions.setIsFetching(false));
        notification.error({
          message: res?.response?.data?.message,
        });
        return { type: false, token: "" };
      }
    } catch (err) {
      dispatch(authActions.setIsFetching(false));
      notification.error({
        message: "You might be experiencing network issues.",
      });
      console.error(err);
    }
  };
};

export const getUserprofileAction = (token, navigate) => {
  return async (dispatch) => {
    try {
      dispatch(authActions.setProfileIsFetching(true));
      const res = await profileService(token);
      if (res?.status === "1") {
        dispatch(authActions.setIsLoggingIn(false));
        setUserSession(token, [res?.data?.user]);
        dispatch(authActions.setUser(res.data?.user));
        dispatch(authActions.setIsUserLoggedIn(true));
        dispatch(authActions.setProfileIsFetching(false));
        dispatch(authActions.setToken({ token }));
        return { type: true, userType: res?.data?.user?.type };
      } else if ([undefined, 500, 401, "0"]?.includes(res?.status)) {
        sessionStorage.clear();
        dispatch(authActions.setToken(" "));
        dispatch(authActions.setUser(null));
        navigate("/");
        dispatch(authActions.setProfileIsFetching(false));
      }
      dispatch(authActions.setProfileIsFetching(false));
      return { type: false, userType: "" };
    } catch (err) {
      console.log(err);
      dispatch(authActions.setProfileIsFetching(false));
    }
  };
};

export const logoutAction = (data, navigate) => {
  return async (dispatch) => {
    try {
      await logoutService(data);
      sessionStorage.clear();
      dispatch(authActions.setToken(" "));
      dispatch(authActions.setUser(null));
      dispatch(authActions.setIsUserLoggedIn(false));
      if (navigate) {
        navigate("/");
      }
    } catch (err) {
      console.error(err);
      // Even if the logout API fails, we should still clear local session to ensure user is logged out locally
      sessionStorage.clear();
      dispatch(authActions.setToken(" "));
      dispatch(authActions.setUser(null));
      dispatch(authActions.setIsUserLoggedIn(false));
      if (navigate) {
        navigate("/");
      }
    }
  };
};


